const LoadingIndicator = ({ label = 'Loading...', className = '', center = true }) => (
  <div className={`app-loading ${center ? 'app-loading-center' : ''} ${className}`.trim()} role="status" aria-live="polite">
    <span className="app-loading-spinner" aria-hidden />
    <span className="app-loading-text">{label}</span>
  </div>
);

export default LoadingIndicator;
